import { isValidElement, ReactNode } from 'react';
import { IBordTableAction } from 'types/tableWithActions.types';
import BordTableAction from '../components/BordTableAction';

export function renderActions(actions: ReactNode[] | IBordTableAction[]) {
  if (!actions || actions.length === 0) return null;

  const renderModuleFiltersExpandibleSelect = (action: IBordTableAction, index: number) => {
    return <BordTableAction key={`act-${action.text || index}`} {...action} />;
  };

  return actions.map((action, index) =>
    isValidElement(action) ? action : renderModuleFiltersExpandibleSelect(action as IBordTableAction, index)
  );
}
